import { render, staticRenderFns } from "./Theming.vue?vue&type=template&id=3c1a2cc8"
import script from "./Theming.vue?vue&type=script&lang=js"
export * from "./Theming.vue?vue&type=script&lang=js"
import style0 from "./Theming.vue?vue&type=style&index=0&id=3c1a2cc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports